import { ModelRule } from 'src/containers/ProjectDiagram/types/data';
import { ExportToFileOptions } from 'src/utils/exportToFile';

export enum CreationType {
  NEW = 'NEW',
  REPLACE = 'REPLACE',
  APPEND = 'APPEND',
}

export type DatabaseInfo = {
  databaseId: string;
  shouldEnableVoicebox?: boolean;
  isPublishingVoiceboxQuestions?: boolean;
  isPublishingSPG: boolean;
};

export type ModelInfo = {
  creationType: CreationType;
  modelName: string;
  namedGraphIri: string;
  projectModelId: string;
  shouldPublish: boolean;
};

export type ModelAliasInfo = {
  creationType: CreationType;
  modelName: string;
  namedGraphIris: string[];
};

export type ModelsInfo = Record<string, ModelInfo>;

export type PrefixInfo = {
  isConflicted: boolean;
  namespace: string;
  prefix: string;
  shouldPublish: boolean;
};

export type CsvMappingInfo = {
  creationType: CreationType;
  fileOptions: ExportToFileOptions | null;
  namedGraphIri: string;
  shouldPublish: boolean;
};

export type CsvMappingInfoByProjectFileUploadId = Record<
  string,
  CsvMappingInfo
>;

export type VirtualGraphMappingInfo = {
  creationType: CreationType;
  projectVgId: string;
  virtualGraphName: string;
  shouldPublish: boolean;
};

export type VirtualGraphMappingInfoByProjectVgId = Record<
  string,
  VirtualGraphMappingInfo
>;

export type RulesInfo = Record<string, ModelRule>;

export type SensitivePropertyGroupInfo = {
  spgName: string;
  actionType: CreationType;
  publishName: string;
  attributes: string[];
};

export type SensitivePropertyGroupsInfo = Record<
  string,
  SensitivePropertyGroupInfo
>;
